import React, { useRef } from 'react'
import { ReactComponent as SubmitReview } from 'components/UI/icons/revision_info.svg'
import style from './ReviewInfoBlock.module.scss'
import DiscussionButton from './DiscussionButton/DiscussionButton'

const ReviewInfoBlock = ({
  scrollToBlock,
  translate,
  title = translate.teacher_sent_for_revision,
}) => {
  return (
    <div className={style.container}>
      <div className={style.mainBlock}>
        <SubmitReview />
        <span>{title}</span>
      </div>
      <DiscussionButton translate={translate} scrollToBlock={scrollToBlock} />
    </div>
  )
}

export default ReviewInfoBlock
